/*
    exclude or mask elements from FS
    https://help.fullstory.com/hc/en-us/articles/360020623574
*/

interface IFSPrivacy {
    privacy?: 'mask' | 'exclude' | 'unmask';
    children: any;
}

const FSPrivacy: React.FC<IFSPrivacy> = ({ privacy = 'exclude', children }) => {
    return (<div className={`fs-${privacy}`}>{children}</div>);
}

const applyPrivacy = <T extends object>(
    Component: React.FC<T>,
    privacy: 'mask' | 'exclude' | 'unmask'
  ) => {
    const call = (props: Parameters<typeof Component>[0]) => {
      return <div className={`fs-${privacy}`}><Component {...props} /></div>;
    };
    return call;
  };

export const applyMask = <T extends object>(
    Component: React.FC<T>
  ) => {
    return applyPrivacy(Component, 'mask');
  }

export const applyExclude = <T extends object>(
    Component: React.FC<T>
  ) => {
    return applyPrivacy(Component, 'exclude');
  }

export default FSPrivacy;
